/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type UpdateEventParentWrappersSubscriptionInput = {
    calendarIds: Array<string>;
    dates: Array<unknown>;
    includeAllDay?: boolean | null | undefined;
    orgRelayId: string;
    timeZone: string;
};
export type UpdateEventParentWrappersSubscriptionVariables = {
    input: UpdateEventParentWrappersSubscriptionInput;
};
export type UpdateEventParentWrappersSubscriptionResponse = {
    readonly updateEventParentWrappers: {
        readonly eventParentWrappers: ReadonlyArray<{
            readonly id: string;
            readonly deleted: boolean;
            readonly eventParents: ReadonlyArray<{
                readonly events: ReadonlyArray<{
                    readonly title: string | null;
                    readonly locked: boolean | null;
                    readonly isClockwiseEvent: boolean;
                    readonly isAllDay: boolean | null;
                    readonly calendarIds: ReadonlyArray<string>;
                    readonly organizer: {
                        readonly urnValue: string;
                        readonly responseStatus: ResponseStatusEnum | null;
                    } | null;
                    readonly creator: {
                        readonly urnValue: string;
                    } | null;
                    readonly attendees: ReadonlyArray<{
                        readonly urnValue: string;
                        readonly responseStatus: ResponseStatusEnum | null;
                    }>;
                    readonly annotatedEvent: {
                        readonly userTags: ReadonlyArray<{
                            readonly tag: string;
                            readonly states: ReadonlyArray<{
                                readonly subjectType: SubjectUrnTypeEnum;
                                readonly subjectValue: string;
                                readonly value: string | null;
                            }> | null;
                        }> | null;
                        readonly orgTags: ReadonlyArray<{
                            readonly tag: string;
                            readonly state: {
                                readonly subjectType: SubjectUrnTypeEnum;
                                readonly subjectValue: string;
                                readonly value: string | null;
                            };
                        }> | null;
                    } | null;
                    readonly eventKey: {
                        readonly externalEventId: string;
                    };
                    readonly location: string | null;
                    readonly startTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly millis: number;
                        readonly offsetMinutes: number | null;
                    };
                    readonly endTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly millis: number;
                        readonly offsetMinutes: number | null;
                    };
                }>;
            }>;
        }> | null;
    };
};
export type UpdateEventParentWrappersSubscription = {
    readonly response: UpdateEventParentWrappersSubscriptionResponse;
    readonly variables: UpdateEventParentWrappersSubscriptionVariables;
};



/*
subscription UpdateEventParentWrappersSubscription(
  $input: UpdateEventParentWrappersSubscriptionInput!
) {
  updateEventParentWrappers(input: $input) {
    eventParentWrappers {
      id
      deleted
      eventParents {
        events {
          title
          locked
          isClockwiseEvent
          isAllDay
          calendarIds
          organizer {
            urnValue
            responseStatus
          }
          creator {
            urnValue
          }
          attendees {
            urnValue
            responseStatus
          }
          annotatedEvent {
            userTags {
              tag
              states {
                subjectType
                subjectValue
                value
              }
            }
            orgTags {
              tag
              state {
                subjectType
                subjectValue
                value
              }
            }
            id
          }
          eventKey {
            externalEventId
            id
          }
          location
          startTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
          endTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClockwiseEvent",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v10 = [
        (v9 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": (v10 /*: any*/),
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
            (v9 /*: any*/)
        ],
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "attendees",
        "plural": true,
        "selections": (v10 /*: any*/),
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v15 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "UserTag",
        "kind": "LinkedField",
        "name": "userTags",
        "plural": true,
        "selections": [
            (v14 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "states",
                "plural": true,
                "selections": (v15 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgTag",
        "kind": "LinkedField",
        "name": "orgTags",
        "plural": true,
        "selections": [
            (v14 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": (v15 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
    } as any, v20 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v21 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v20 /*: any*/),
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v20 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateEventParentWrappersSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateEventParentWrappersSubscriptionPayload",
                    "kind": "LinkedField",
                    "name": "updateEventParentWrappers",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParentWrapper",
                            "kind": "LinkedField",
                            "name": "eventParentWrappers",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventParent",
                                    "kind": "LinkedField",
                                    "name": "eventParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "kind": "LinkedField",
                                            "name": "events",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AnnotatedEvent",
                                                    "kind": "LinkedField",
                                                    "name": "annotatedEvent",
                                                    "plural": false,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventKey",
                                                    "kind": "LinkedField",
                                                    "name": "eventKey",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Subscription",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateEventParentWrappersSubscription",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateEventParentWrappersSubscriptionPayload",
                    "kind": "LinkedField",
                    "name": "updateEventParentWrappers",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParentWrapper",
                            "kind": "LinkedField",
                            "name": "eventParentWrappers",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventParent",
                                    "kind": "LinkedField",
                                    "name": "eventParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "kind": "LinkedField",
                                            "name": "events",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v6 /*: any*/),
                                                (v7 /*: any*/),
                                                (v8 /*: any*/),
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AnnotatedEvent",
                                                    "kind": "LinkedField",
                                                    "name": "annotatedEvent",
                                                    "plural": false,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventKey",
                                                    "kind": "LinkedField",
                                                    "name": "eventKey",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/),
                                                (v21 /*: any*/),
                                                (v22 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "81a2aff8bd35611bde45e92430681f11",
            "id": null,
            "metadata": {},
            "name": "UpdateEventParentWrappersSubscription",
            "operationKind": "subscription",
            "text": "subscription UpdateEventParentWrappersSubscription(\n  $input: UpdateEventParentWrappersSubscriptionInput!\n) {\n  updateEventParentWrappers(input: $input) {\n    eventParentWrappers {\n      id\n      deleted\n      eventParents {\n        events {\n          title\n          locked\n          isClockwiseEvent\n          isAllDay\n          calendarIds\n          organizer {\n            urnValue\n            responseStatus\n          }\n          creator {\n            urnValue\n          }\n          attendees {\n            urnValue\n            responseStatus\n          }\n          annotatedEvent {\n            userTags {\n              tag\n              states {\n                subjectType\n                subjectValue\n                value\n              }\n            }\n            orgTags {\n              tag\n              state {\n                subjectType\n                subjectValue\n                value\n              }\n            }\n            id\n          }\n          eventKey {\n            externalEventId\n            id\n          }\n          location\n          startTime {\n            type\n            dateOrDateTime\n            timeZone\n            millis\n            offsetMinutes\n          }\n          endTime {\n            type\n            dateOrDateTime\n            timeZone\n            millis\n            offsetMinutes\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2591aa619af42b8326f13185be67ed37';
export default node;
